import Pikaday from 'pikaday'
import FormImageUploadGroupController from './form-image-upload-group-controller'
import FormInputClassesController from './form-input-classes-controller'

import moment from 'moment'
import Pristine from 'pristinejs'

const ERROR_TEXT_CLASS = 'form__group__text-help'

export default class GetScoutedFormController {
  constructor (element) {
    this._element = element
    this._initValidator(false)
    this._bindUIActions()
  }

  _scrollToValidationError () {
    const firstErrorElement = this._element.querySelector('.form__group--has-danger')
    if (firstErrorElement) {
      firstErrorElement.scrollIntoView({
        behavior: 'smooth', block: 'center'
      })
    }
  }

  _initValidator (live = true) {
    if (this._pristine) this._pristine.destroy()
    this._pristine = new Pristine(this._element, {
      // class of the parent element where the error/success class is added
      classTo: 'form__group',
      errorClass: 'form__group--has-danger',
      successClass: 'form__group--has-success',
      // class of the parent element where error text element is appended
      errorTextParent: 'form__group',
      // type of element to create for the error text
      errorTextTag: 'div',
      // class of the error text element
      errorTextClass: ERROR_TEXT_CLASS
    }, live)
  }

  _bindUIActions () {
  // eslint-disable-next-line no-new
    new FormInputClassesController(this._element)

    const imageUploadGroups = this._element.querySelectorAll('.form-image-upload-group')
  ;[].forEach.call(imageUploadGroups, element => {
    // eslint-disable-next-line no-new
      new FormImageUploadGroupController(element)
    })

    const dateInputs = this._element.querySelectorAll('.form-input-field--date .form-input-field__input')
  ;[].forEach.call(dateInputs, (element) => {
      console.log('dateInputs', element)
      const datepicker = new Pikaday({
        format: 'DD-MM-YYYY',
        maxDate: new Date(),
        defaultDate: new Date(2000, 0, 1),
        yearRange: 30, // [1960, new Date().getFullYear()],
        field: element,
        onSelect: () => {
          this._pristine.validate(element)
        }
      })
      element.type = 'text'
    })

    this._element.addEventListener('submit', e => {
      // check if the form is valid
      this._initValidator()
      var valid = this._pristine.validate() // returns true or false

      if (!valid) {
        e.preventDefault()
        this._scrollToValidationError()
      }
    })
  }
}
